export default {
  getMenus: {
    url: '/menu',
    method: 'get',
  },
  showRegistersByCode: {
    url: '/api/showRegistersByCode',
  },
  sendMail: {
    url: '/api/sendMail',
  }
};